module.exports = __webpack_public_path__ + "img/seller.90945d98.png";